<template>
  <div class="vz-user-menu">
    <div class="vz-user-menu-trigger" @click.stop="toggleMenu">
      <span class="vz-user-menu-trigger-label">{{ greeting }}</span>
      <span class="vz-user-menu-trigger-ic">
        <img
          v-if="profilePicture"
          class="vz-user-menu-photo"
          :src="profilePicture"
          alt=""
        />
        <i v-else class="ic-user vz-user-menu-ic"></i>
      </span>
    </div>
    <transition>
      <div class="vz-user-menu-content" v-show="open" @click.stop="closeMenu">
        <div class="vz-user-menu-items">
          <div class="vz-user-menu-info">
            <span class="vz-user-menu-info-label">{{ greeting }}</span>
            <span class="vz-user-menu-info-ic">
              <img
                v-if="profilePicture"
                class="vz-user-menu-photo"
                :src="profilePicture"
                alt=""
              />
              <i v-else class="ic-user vz-user-menu-ic"></i>
            </span>
          </div>
          <ul class="vz-user-menu-links">
            <template v-for="item in items">
              <li
                class="vz-user-menu-item vz-user-menu-item-has-submenu"
                v-if="item.items && item.items.length"
                :class="{ 'vz-expanded': submenu === item.items }"
              >
                <span
                  class="vz-user-menu-label"
                  @click.stop="toggleSubmenu(item)"
                >
                  {{ item.label }}
                  <i class="ic-chevron-down vz-ic"></i>
                </span>
                <ul class="vz-user-submenu">
                  <li
                    class="vz-user-menu-subitem"
                    v-for="subitem in item.items"
                  >
                    <vz-link
                      class="vz-user-menu-link vz-user-subitem-link"
                      :to="subitem.link"
                      >{{ subitem.label }}</vz-link
                    >
                  </li>
                </ul>
              </li>
              <li class="vz-user-menu-item" v-else>
                <vz-link class="vz-user-menu-link" :to="item.link">
                  {{ item.label }}
                </vz-link>
              </li>
            </template>
          </ul>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import VzLink from 'vsp-web-ui-lib/components/atoms/vz-link.vue';

export default {
  name: 'VzUserMenu',
  emits: ['open', 'close'],
  components: {
    VzLink
  },

  props: {
    items: {
      type: Array,
      default: () => []
    },
    userName: {
      type: String,
      default: ''
    }
  },

  data: () => ({
    open: false,
    submenu: null
  }),

  computed: {
    greeting() {
      let res = 'Olá';
      const maxLength = 30;
      if (this.userName) {
        const { userName } = this;
        const splitName = userName.split(' ');
        const firstName = splitName[0];
        const userNameLength = firstName.substr(0, maxLength);
        res += `, ${userNameLength}`;
        if (userNameLength.length >= maxLength) {
          res += '...';
        } else {
          res += '!';
        }
      }
      return res;
    },

    profilePicture() {
      return this.$store.state.user.user.profilePicture || '';
    }
  },

  methods: {
    openMenu() {
      this.open = true;
      this.$emit('open');
    },

    closeMenu() {
      this.open = false;
      this.$emit('close');
    },

    toggleMenu() {
      if (this.open) {
        this.closeMenu();
      } else {
        this.openMenu();
      }
    },

    toggleSubmenu(parentItem) {
      this.submenu =
        this.submenu === parentItem.items ? null : parentItem.items;
    }
  }
};
</script>

<style theme="dark-theater" scoped>
.vz-user-menu-trigger {
  display: inline-block;
}

.vz-user-menu-trigger:hover {
  color: var(--link-color-over);
}

.vz-user-menu-trigger:active {
  color: var(--link-color-active);
}

.vz-user-menu-trigger-label {
  display: none;
  vertical-align: middle;
}

.vz-user-menu-trigger-ic,
.vz-user-menu-info-ic {
  width: 26px;
  height: 26px;
  overflow: hidden;
  border: 2px solid #ffffff;
  border-radius: 50%;
  display: inline-flex;
  justify-content: center;
  align-items: center;
}

.vz-user-menu-trigger-ic {
  vertical-align: middle;
}

.vz-user-menu-trigger:hover .vz-user-menu-trigger-ic {
  border-color: var(--link-color-over);
}

.vz-user-menu-trigger:active .vz-user-menu-trigger-ic {
  border-color: var(--link-color-active);
}

.vz-user-menu-ic {
  font-size: 20px;
}

.vz-user-menu-info-ic .vz-user-menu-ic {
  font-size: 16px;
}

.vz-user-menu-photo {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.vz-user-menu-trigger:hover .vz-user-menu-ic {
  color: var(--link-color-over);
}

.vz-user-menu-trigger:active .vz-user-menu-ic {
  color: var(--link-color-active);
}

.vz-user-menu-content {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.6);
  overflow: hidden;
}

.vz-user-menu-content.v-enter-active,
.vz-user-menu-content.v-leave-active {
  transition-property: opacity;
  transition-duration: 0.3s;
}

.vz-user-menu-content.v-leave-active {
  transition-delay: 0.3s;
}

.vz-user-menu-content.v-enter,
.vz-user-menu-content.v-enter-from,
.vz-user-menu-content.v-leave-to {
  opacity: 0;
}

.vz-user-menu-content.v-leave,
.vz-user-menu-content.v-leave-from,
.vz-user-menu-content.v-enter-to {
  opacity: 1;
}

.vz-user-menu-items {
  position: absolute;
  top: 0;
  right: 0;
  height: 100%;
  width: 95%;
  max-width: 360px;
  background-color: #0c0c0c;
  padding: 0;
  box-shadow: 1px 0 8px rgba(0, 0, 0, 0.57);
  transform: translate(0, 0);
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: stretch;
}

.vz-user-menu-content.v-enter-active .vz-user-menu-items,
.vz-user-menu-content.v-leave-active .vz-user-menu-items {
  transition-property: transform;
  transition-duration: 0.3s;
}

.vz-user-menu-content.v-enter .vz-user-menu-items,
.vz-user-menu-content.v-enter-from .vz-user-menu-items,
.vz-user-menu-content.v-leave-to .vz-user-menu-items {
  transform: translate(110%, 0);
}

.vz-user-menu-content.v-leave .vz-user-menu-items,
.vz-user-menu-content.v-leave-from .vz-user-menu-items,
.vz-user-menu-content.v-enter-to .vz-user-menu-items {
  transform: translate(0, 0);
}

.vz-user-menu-info {
  flex-grow: 0;
  flex-basis: 0;
  padding: 24px 32px 24px 24px;
  display: flex;
  flex-direction: row-reverse;
  justify-content: flex-end;
  align-items: center;
  background-color: rgba(255, 255, 255, 0.05);
}

.vz-user-menu-info-label,
.vz-user-menu-trigger-label {
  font-size: 0.92em;
}

.vz-user-menu-info-ic {
  display: inline-block;
  margin-right: 8px;
  width: 20px;
  height: 20px;
}

.vz-user-menu-links {
  flex-grow: 2;
  height: 100%;
  overflow: auto;
  padding: 0;
  margin: 0;
  font-size: 0.82em;
}

.vz-user-menu-item {
  display: block;
}

.vz-user-menu-label,
.vz-user-menu-link {
  display: block;
  padding: 16px 32px;
  text-decoration: none;
  border-width: 0;
  transition: background-color 0.3s;
  color: rgba(255, 255, 255, 0.5);
  transition-property: color, background-color;
  transition-duration: 0.3s;
  position: relative;
  cursor: pointer;
}

.vz-user-menu-label:hover,
.vz-user-menu-link:hover {
  background-color: rgba(255, 255, 255, 0.05);
  color: rgba(255, 255, 255, 0.7);
}

.vz-user-menu-label:active,
.vz-user-menu-link:active {
  background-color: rgba(255, 255, 255, 0.1);
  color: #ffffff;
}

.vz-user-menu-link.nuxt-link-active,
.vz-user-menu-link.nuxt-link-active:hover,
.vz-user-menu-link.nuxt-link-active:active {
  background-color: rgba(255, 255, 255, 0.15);
  color: #ffffff;
  cursor: default;
}

.vz-user-menu-link.nuxt-link-active:before {
  content: '';
  display: block;
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 8px;
  background-color: var(--primary-color);
}

.vz-user-menu-label {
  position: relative;
  cursor: pointer;
}

.vz-user-menu-label:hover {
  color: var(--link-color-over);
}

.vz-user-menu-label .vz-ic {
  position: absolute;
  top: 50%;
  right: 16px;
  font-size: 16px;
  color: rgba(255, 255, 255, 0.5);
  transform: translate(0, -50%);
}

.vz-expanded .vz-user-menu-label .vz-ic {
  transform: translate(0, -50%) rotateZ(180deg);
}

.vz-user-submenu {
  margin: 0;
  padding: 0;
  overflow: hidden;
  max-height: 0;
  transition-property: max-height;
  transition-duration: 0.3s;
}

.vz-expanded .vz-user-submenu {
  max-height: 1080px;
}

.vz-user-menu-subitem {
  display: block;
  border-top: 1px solid rgba(255, 255, 255, 0.05);
}

@media (min-width: 1024px) {
  .vz-user-menu-trigger {
    white-space: nowrap;
    cursor: pointer;
  }

  .vz-user-menu-trigger-label {
    display: inline-block;
    font-size: 0.92em;
  }

  .vz-user-menu-trigger-ic {
    margin-left: 8px;
  }
}
</style>

















































































































































































































































































